import { makeStyles } from 'tss-react/mui';
import { Theme } from '@mui/material/styles/createTheme';
import { MENU_WIDTH } from '../../../styles/constants';

export const useStyles = makeStyles<Theme>()((theme) => ({
  menuWrapper: {
    width: MENU_WIDTH,
    height: '100%',
  },

  menuContainer: {
    paddingTop: theme.spacing(1),
    backgroundColor: theme.palette.background.paper,
    borderRadius: '0 0 4px 4px',

    '& ul': {
      padding: theme.spacing(1),
      margin: 0,
    },
  },

  menuItemLink: {
    color: 'unset',
    textDecoration: 'unset',

    '& li': {
      borderBottom: `1px solid ${theme.palette.grey[200]}`,
    },
    '&:last-child li': {
      borderBottom: 'unset',
    },
  },
  menuItem: {
    display: 'flex',
    margin: '4px',
    padding: '8px 0',
    alignItems: 'center',
    cursor: 'pointer',
    flex: 1,
    color: theme.palette.font.secondary,

    '& span': {
      width: '100%',
    },

    '&:hover svg:last-child': {
      color: theme.palette.primary.main,
    },
    '& svg:first-child': {
      height: '20px',
      width: '20px',
      marginRight: '4px',
    },
  },
  counter: {
    marginLeft: '4px',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default,
    maxWidth: '20px',
    width: '20px',
    maxHeight: '20px',
    textAlign: 'center',
    borderRadius: '50%',
  },

  menuItemHover: {
    '&:hover': {
      backgroundColor: theme.palette.grey[50],
      borderRadius: '4px',
      color: theme.palette.primary.main,
    },
  },
  active: {
    color: `${theme.palette.primary.main} !important`,
    '& svg': {
      color: theme.palette.primary.main,
    },
  },
}));
